import { createTurtleRequestMessage } from 'src/utils/voicebox/messages';

export const REREQUEST_FOR_SYNTAX_MESSAGE = createTurtleRequestMessage({
  userPrompt:
    'The previous turtle doc is synctactically invalid. PLease provide a fixed turtle doc, in a code block using backticks.',
  hidden: true,
});

export const REREQUEST_FOR_PREFIXES_MESSAGE = createTurtleRequestMessage({
  userPrompt: `The previous turtle doc had undefined prefixes. Please provide a fixed turtle doc with these prefixes defined, in a code block using backticks.`,
  hidden: true,
});
